import { useUserInfo } from "../../context/user";

import "./style.css";
import { useDashboardLocationChatCount } from "../../queries/calendar";

const Dashboard = () => {
  const location = useUserInfo();
  const { data: totalMatchLocationfromchat = 0 } = useDashboardLocationChatCount(location._id);

  return (
    <>
      <div className="page-shell-wide position-relative extraPadding" style={{ height: '100vh' }}>
        <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
          <div style={{ width: "calc(33.33% - 10px)", boxShadow: "10px", borderRadius: "5px", marginBottom: "10px" }}>

            <div className="statistics-card">
              <div className="statistics-card-title">No of Chats</div>
              <div className="statistic" >
                <div className="statistic-icon">{totalMatchLocationfromchat}</div>
                <div className="statistic-value">Total Chats</div>
              </div>
            </div>
          </div>
          <div style={{ width: "calc(33.33% - 10px)", boxShadow: "10px", borderRadius: "5px", marginBottom: "10px" }}>

            <div className="statistics-card">
              <div className="statistics-card-title">Total API Calls</div>
              <div className="statistic" >
                <div className="statistic-icon">0</div>
                <div className="statistic-value"> API Calls</div>
              </div>
            </div>
          </div>
          <div style={{ width: "calc(33.33% - 10px)", boxShadow: "10px", borderRadius: "5px", marginBottom: "10px" }}>

            <div className="statistics-card">
              <div className="statistics-card-title">Total Amount Spend</div>
              <div className="statistic" >
                <div className="statistic-icon">0</div>
                <div className="statistic-value">Spend</div>
              </div>
            </div>
          </div>
          <div style={{ width: "calc(33.33% - 10px)", boxShadow: "10px", borderRadius: "5px", marginBottom: "10px" }}>

            <div className="statistics-card">
              <div className="statistics-card-title">Total Post Generated</div>
              <div className="statistic" >
                <div className="statistic-icon">0</div>
                <div className="statistic-value">Post Generated</div>
              </div>
            </div>
          </div>
          <div style={{ width: "calc(33.33% - 10px)", boxShadow: "10px", borderRadius: "5px", marginBottom: "10px" }}>

            <div className="statistics-card">
              <div className="statistics-card-title">Total Remaining Balance</div>
              <div className="statistic" >
                <div className="statistic-icon">0</div>
                <div className="statistic-value">Remaining Balance</div>
              </div>
            </div>
          </div>
          <div style={{ width: "calc(33.33% - 10px)", boxShadow: "10px", borderRadius: "5px", marginBottom: "10px" }}>

            <div className="statistics-card">
              <div className="statistics-card-title">Total Users</div>
              <div className="statistic" >
                <div className="statistic-icon">0 </div>
                <div className="statistic-value">Users</div>
              </div>
            </div>
          </div>


        </div>

      </div>
    </>
  )
}
export default Dashboard